import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { useState } from 'react';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { label: 'Strona główna', path: '/' },
    { label: 'Psy do adopcji', path: '/dogs' },
    { label: 'O nas', path: '/about' },
    { label: 'Wspomóż nas', path: '/support' },
    { label: 'Przetargi', path: '/przetargi' },
    { label: 'Kontakt', path: '/contact' }
  ];

  return (
    <nav className="main-nav">
      <div className="site-container">
        <div className="main-nav__inner">
          {/* Logo */}
          <Link to="/" className="brand-mark" aria-label="Schronisko AZYL — strona główna">
            <img src="/logo.png" alt="" width="48" height="48" />
            <div className="brand-mark__text">
              <strong>Schronisko AZYL</strong>
              <span>Dzierżoniów</span>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="main-nav__links">
            {navItems.map(item => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) => `main-nav__link${isActive ? ' is-active' : ''}`}
              >
                {item.label}
              </NavLink>
            ))}
          </div>

          <Link to="/support" className="main-nav__cta">Wesprzyj AZYL</Link>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="main-nav__toggle"
            aria-label={isOpen ? 'Zamknij menu' : 'Otwórz menu'}
            aria-expanded={isOpen}
          >
            {isOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="main-nav__mobile">
            {navItems.map(item => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) => `main-nav__mobile-link${isActive ? ' is-active' : ''}`}
                onClick={() => setIsOpen(false)}
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}
